import { useCurrentUser } from '@qualio/ui-components';
import { useMemo } from 'react';

export const useComplianceAccess = () => {
  const user = useCurrentUser();

  const hasComplianceAccess = useMemo(() => {
    const isCapabilityEnabled = Boolean(user.capabilities?.compliance);
    const hasPermission = Boolean(user.permissions.can_access_compliance);
    return isCapabilityEnabled && hasPermission;
  }, [user]);

  return hasComplianceAccess;
};
